export const MAIN_STATUSES = [
  "New",
  // "Prospects",
  "Contacted",
  "Follow-Up",
  "Completed"
];

export const PROSPECT_SUB_STATUSES = [
  "No Answer",
  "Invalid / Wrong Number",
  "Spoke – Follow-up Scheduled",
  "Interested",
  "Not Interested",
  "Not Relevant",
  "Follow-Up Scheduled",
  "Follow-Up Overdue",
  "Duplicate Lead",
  "Do Not Contact (DNC)",
  "WhatsApp Sent – No Response",
  "WhatsApp Replied"
];

export const ALL_STATUSES = [
  ...MAIN_STATUSES,
  ...PROSPECT_SUB_STATUSES,
  // "Meetings",
  "Deals Won",
  "Deals Lost",
  "Meeting-Scheduled"
];

export const LEAD_STATUSES = ALL_STATUSES; // for backward compatibility if needed
